export const initialItemRebuzzStatistics = {
  commentCount: 0,
  reactions: {},
  rebuzzCount: 0,
  statistics: [
    // {
    //   id: number,
    //   userId: string,
    //   profilePicUrl: string,
    //   boostTag: string,
    //   boostAmount: number,
    //   rebuzzTo: {
    //     orgId: string,
    //     streamId: string,
    //     channelId: string,
    //   },
    //   //'2023-11-21T14:51:54.023Z',
    //   rebuzzedAt: string,
    // },
  ],
};

export const initialRebuzzSelectedTags = {
  byId: {},
  byBoost: {},
  totalPrice: 0,
};
